var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
const LanguageToggleContainer = styled.ul `
  display: flex;
  list-style: none;
  margin: 0;
  padding-left: 0;
  align-items: center;
`;
const ItemContainer = styled.li `
  margin-right: 5px;
  .divider {
    margin-left: 5px;
  }

  &:last-child {
    margin-right: 0px;
    .divider {
      display: none;
    }
  }
`;
const ToggleLink = styled((_a) => {
    var { isLanguageSelected, theme, ariaLabel } = _a, rest = __rest(_a, ["isLanguageSelected", "theme", "ariaLabel"]);
    const newProps = ariaLabel ? Object.assign(Object.assign({}, rest), { 'aria-label': ariaLabel }) : Object.assign({}, rest);
    return React.createElement("a", Object.assign({}, newProps));
}) `
  border-bottom: ${({ isLanguageSelected, theme }) => isLanguageSelected ? `3px solid ${theme.primaryRed}` : 'none'};
  font-style: normal;
  font-family: ${({ isLanguageSelected, theme }) => isLanguageSelected ? theme.fontFamilyBold : theme.fontFamilyBase};
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.primaryBlack};
  cursor: pointer;

  &:active,
  &:focus,
  &:hover {
    color: ${({ theme }) => theme.primaryRed};
  }

  ${media.tablet} {
    line-height: ${({ isLanguageSelected }) => (isLanguageSelected ? '22px' : '24px')};
  }
`;
export const LanguageToggle = ({ languages = [
    {
        languageCode: 'en',
        href: '/en',
        text: 'EN',
    },
    {
        languageCode: 'fr',
        href: '/fr',
        text: 'FR',
    },
], currentLanguage = 'en', }) => {
    return (React.createElement(LanguageToggleContainer, null, languages.map(({ languageCode, text, href }) => {
        const isLanguageSelected = languageCode === currentLanguage;
        return (React.createElement(ItemContainer, { key: languageCode },
            React.createElement(ToggleLink, { tabIndex: 0, href: href, isLanguageSelected: isLanguageSelected, ariaLabel: text }, text),
            React.createElement("span", { className: "divider" }, "/")));
    })));
};
